import { render } from "./PropertyEditor.vue?vue&type=template&id=0f9685fc&scoped=true"
import script from "./PropertyEditor.vue?vue&type=script&lang=js"
export * from "./PropertyEditor.vue?vue&type=script&lang=js"

import "./PropertyEditor.vue?vue&type=style&index=0&id=0f9685fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9685fc"]])

export default __exports__